// removed by extract-text-webpack-plugin
module.exports = {"image-wrapper":"ZoomableImage-module-image-wrapper-__4ry","imageWrapper":"ZoomableImage-module-image-wrapper-__4ry","actions":"ZoomableImage-module-actions-nvzF5","button":"ZoomableImage-module-button-1SQag"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ZoomableImage/ZoomableImage.module.scss
// module id = 1083
// module chunks = 0